// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__pxm2u","offer__bg":"Container_offer__bg__l_NsY"};